import { render, staticRenderFns } from "./ReportGlobalvalueRecordLife.vue?vue&type=template&id=130dc4de&scoped=true&"
import script from "./ReportGlobalvalueRecordLife.vue?vue&type=script&lang=js&"
export * from "./ReportGlobalvalueRecordLife.vue?vue&type=script&lang=js&"
import style0 from "./ReportGlobalvalueRecordLife.vue?vue&type=style&index=0&id=130dc4de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130dc4de",
  null
  
)

export default component.exports